<template>
  
  <div>

    <div id="first-access-dialog" class="ui tiny modal first-access-modal">

      <div class="ui header">
        Primeiro acesso
      </div>

      <div class="content">

        <p class="grey text">Informe o CNPJ da sua empresa para se cadastrar e consultar o estoque de oportunidades da Cobrecom</p>

        <form class="ui form m-t-10" @submit.prevent="onConfirmCnpj()">
          <div class="ui field">
            <div class="ui left icon large input">
              <the-mask type="tel" placeholder="00.000.000/0000-00" mask="##.###.###/####-##" v-model="cnpj" />
              <i class="info circle icon"></i>
            </div>
          </div>
        </form>

      </div>

      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i>
          Cancelar
        </button>
        <button type="button" class="ui blue button" :class="{ loading }" @click="onConfirmCnpj()">
          <i class="check icon"></i>
          Confirmar
        </button>
      </div>

    </div>

    <create-customer-dialog :cnpj="cnpj" @onCreate="onCreateCustomer" />
    <create-user-dialog :customer="customer" @onCreate="onCreateUser" />

  </div>

</template>

<script>

  import { TheMask } from "vue-the-mask"
  import Message from "@/utils/message"
  import CustomerService from "@/services/customer-service"
  import CreateCustomerDialog from "./customer.vue"
  import CreateUserDialog from "./user.vue"

  export default {
    
    data() {
      return {
        loading: false,
        cnpj: "",
        customer: null,
      }
    },

    components: { 
      TheMask,
      CreateCustomerDialog,
      CreateUserDialog,
    },

    beforeDestroy() {
      $(".first-access-modal").remove()
    },

    methods: {

      async onConfirmCnpj() {
        
        if (this.loading || !this.validCnpj())
          return

        this.loading = true

        try {

          this.customer = await CustomerService.getByCnpj(this.cnpj)          
          this.loading = false
          
          this.openDialog("user")
          
        } catch (error) {
          
          this.loading = false
          
          const response = this.$errorHandler(error, { silent: true })

          if (response.errorCode == 404) {
            this.openDialog("customer")
          } else {
            this.$errorHandler(error)
          }
        }

      },

      openDialog(option) {

        $("#first-access-dialog").modal("hide")
        
        setTimeout(() => $(`#create-${option}-dialog`).modal("show"), 1000)
      },

      validCnpj() {

        let isOk = true
        let message = ""

        if (!this.cnpj) {
          message = "Informe o CNPJ"
        } else if (this.cnpj.length < 14) {
          message = "CNPJ inválido"
        }

        if (message) {
          isOk = false
          Message.info(message)
        }

        return isOk
      },

      onCreateCustomer(customer) {

        this.customer = customer

        $("#create-user-dialog").modal("show")
      },

      onCreateUser(user) {

        this.$emit("onCreateUser", this.$cloneObject(user))
      },
    },
    
  }
</script>

